import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/storesReducer";
import rootSaga from "./redux/storesSagas";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import { StoresModule } from "./StoresModule";

const Stores = (props) => {
  const { notifications, ...rest } = props;

  return (
    <Provider store={createReduxStore(reducer, "stores", rootSaga)}>
      <ErrorBoundary moduleName="stores" {...notifications}>
        <StoresModule params={rest} />
      </ErrorBoundary>
    </Provider>
  );
};

export default Stores;
